<template>
  <section class="nf">
    <h1>404</h1>
    <p>Этой страницы нет.</p>
    <RouterLink to="/">На главную</RouterLink>
  </section>
</template>

<style scoped>
.nf { padding: var(--sp-12) 0; text-align: center; }
.nf h1 { font-size: var(--fs-hero); font-family: var(--font-display); margin-bottom: var(--sp-2); }
.nf p { color: var(--text-secondary); margin-bottom: var(--sp-4); }
.nf a { color: var(--accent); }
</style>
